export const data = {
    "id": 2,
    "nome": "Asilo Padre Cacique",
    "imagem": "https://asilopadrecacique.com.br/images/padre.png",
    "descricao": "O Asilo Padre Cacique é uma organização não governamental, sem fins lucrativos. A entidade foi fundada em 19 de junho de 1898 pelo Padre baiano Joaquim Cacique de Barros, que já naquele século realizava obras assistenciais. Filho de um mestre na construção de barcos, nasceu em Ribeira do Itapagipe, Salvador, em 11 de agosto de 1831, tendo, aos 32 anos de idade, vindo morar, exercer o sacerdócio e dedicar-se a causas filantrópicas em Porto Alegre, à época com aproximadamente 20 mil habitantes.",
    "cidade": "Porto Alegre",
    "causa": {
        "id": 13,
        "causa": "Idosos",
        "subCausa": null
    },
    "sobre": "\nO Asilo Padre Cacique é uma organização não governamental, sem fins lucrativos. A entidade foi fundada em 19 de junho de 1898 pelo Padre baiano Joaquim Cacique de Barros, que já naquele século realizava obras assistenciais. Filho de um mestre na construção de barcos, nasceu em Ribeira do Itapagipe, Salvador, em 11 de agosto de 1831, tendo, aos 32 anos de idade, vindo morar, exercer o sacerdócio e dedicar-se a causas filantrópicas em Porto Alegre, à época com aproximadamente 20 mil habitantes. \n \nEm sua longa trajetória, foram muitos os momentos de dificuldades. A Sociedade Humanitária Padre Cacique consolidou seu prestígio e escreveu sua trajetória. Em muitos momentos, a sociedade, organizada para acolher e manter pessoas idosas carentes de ambos os sexos, sem distinção de raça, cor ou credo religioso, enfrentou sérias dificuldades para manter as instituições, como o Colégio de Santa Tereza e o Asilo de Mendicidade Padre Cacique, no século passado, e o Asilo São Joaquim, inaugurado em 1932. \n",
    "url": "https://asilopadrecacique.com.br",
    "doarLink": "https://asilopadrecacique.com.br/ajuda",
    "contato": {
        "id": 2,
        "email": "asilo@asilopadrecacique.com.br",
        "logradouro": "Av. Padre Cacique",
        "numero": 1178,
        "telefone": "(51) 3233-7571",
        "_Links": null,
        "cidade": "Porto Alegre"
    },
    "_Links": [
        {
            "rel": "self",
            "href": "http://localhost:8080/v1/instituicoes/2"
        },
        {
            "rel": "cidades",
            "href": "http://localhost:8080/v1/instituicoes/"
        }
    ]
}